import type { Ref } from "vue";
import { defineQueryOptions, useQuery } from "@pinia/colada";
import TagsAPI from "~/services/tags";
import useUserStore from "~/stores/user";

export const TAGS_QUERY_KEY = {
  root: ["tags"] as const,
  list: (eventId: string) =>
    [...TAGS_QUERY_KEY.root, "list", eventId] as const,
};

type ITagsQueryOptions = {
  id: string;
  staleTime?: number;
  autoRefetch?: boolean;
};

export const tagsQueryOptions = defineQueryOptions(
  (options: ITagsQueryOptions) => ({
    key: TAGS_QUERY_KEY.list(options.id),
    query: async () => {
      const userStore = useUserStore();

      if (!userStore.isAuthenticated) {
        return [];
      }

      return TagsAPI.load({ id: options.id, global: false });
    },
    staleTime: options.staleTime,
    autoRefetch: options.autoRefetch,
    enabled: !!options.id,
  }),
);

export function useTags(options: Ref<ITagsQueryOptions> | (() => ITagsQueryOptions)) {
  return useQuery(tagsQueryOptions, options);
}
